import React from "react";
import { Link } from "react-router-dom";
import KilLayout from "../../../layouts/kil-dashboard/AppLayout";

const KilDashboardSettings = () => {
  return (
    <KilLayout>
      <div className="flex-1 w-full h-full bg-gray-50">
      <p className="text-5xl bg-orange-600 text-white p-4 rounded-lg font-bold">Settings</p>
      </div>
    </KilLayout>
  );
};

export default KilDashboardSettings;
